/**
 * MaintenanceAltIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const MaintenanceAltIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m21.157 18.327-6.85-6.84a2 2 0 0 1-.5-2 6.1 6.1 0 0 0 .1-2.6 6 6 0 0 0-4.82-4.79 5.94 5.94 0 0 0-2.95.21.49.49 0 0 0-.18.82l3.2 3.2a1 1 0 0 1 0 1.4l-1.43 1.43a1 1 0 0 1-1.42 0l-3.18-3.2a.49.49 0 0 0-.82.18 5.94 5.94 0 0 0-.21 2.95 6 6 0 0 0 4.82 4.82 6.1 6.1 0 0 0 2.6-.1 2 2 0 0 1 2 .5l6.85 6.85a1 1 0 0 0 1.42 0l1.37-1.43a1 1 0 0 0 0-1.4" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const MaintenanceAltIcon = makeIcon('MaintenanceAltIcon', MaintenanceAltIconSvg)
